/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CommunityLibrarySettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('COMMUNITY_LIBRARY')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CommunityLibrarySetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommunityLibrarySettingParser.decode(input).map(res => new CommunityLibrarySetting(res));
    }
    static unsafeDecode(input) {
        return CommunityLibrarySetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommunityLibrarySettingParser.encode(data);
    }
    static schema() {
        return CommunityLibrarySettingParser.schema();
    }
}
